import axios from 'axios';

export const GSVSService = {
  async getGSVS(page, perPage, name_query) {
    const res = await axios.get('gsvs/', {
      params: {
        page,
        size: perPage,
        name_query,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },

  async getGSVSById(id) {
    const res = await axios.get(`gsvs/${id}/`);

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createGSVS(data) {
    const res = await axios.post('gsvs/', data);

    if (res.status === 201) {
      return res.data;
    }
    return Promise.reject();
  },
  async editGSVS(data, id) {
    const res = await axios.put(`gsvs/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deleteGSVS(id) {
    const res = await axios.delete(`gsvs/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
